<template>
  <v-layout
    wrap
  >
    <v-flex
      v-for="(image) in form.images"
      :key="image.id"
      md4
      class="image-preview"
      style="overflow:hidden;"
    >
      <div
        class="image-wrapper"
        :class="{default:image.id===form.default_image_id}"
        @click="setDefaultImage(image.id)"
      >
        <v-img
          cover
          max-height="132"
          :src="image.url"
        />
        <div
          v-if="image.id===form.default_image_id"
          class="hint-wrapper blur-box"
        >
          <v-tooltip
            top
          >
            <template #activator="{ on }">
              <v-icon
                color="rgba(255,255,255,0.8)"
                v-on="on"
              >
                mdi-information-outline
              </v-icon>
            </template>
            {{ $t('modules.crowdfunding.selectedAsDef') }}
          </v-tooltip>
        </div>

        <div class="delete-action blur-box">
          <IconCustom
            name="icn24_trash_can"
            color="rgba(255,255,255,0.8)"
            @click.native.stop="removeImage(image.uuid,image.id===form.default_image_id)"
          />
        </div>
      </div>
    </v-flex>
    <v-flex
      v-if="!form.images.length"
      md4
    />
    <v-flex
      md4
      xs12
    >
      <div class="load-image-wrapper">
        <v-progress-circular
          v-if="loading"
          color="primary"
          indeterminate
        />
        <div
          v-if="!loading"
          class="image"
          @click.stop="$refs.image.click()"
        >
          <div
            class="pt-5 pb-7"
          >
            <v-icon color="primary">
              mdi-cloud-upload
            </v-icon>
            <p>
              {{ $t('modules.crowdfunding.uploadImage') }}
            </p>
            <p>PNG / JPG</p>
          </div>
          <input
            ref="image"
            type="file"
            style="display: none"
            accept="image/*"
            @input="setImage"
          >
        </div>
        <div class="text-center mt-2" />
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
import IconCustom from "@/components/helper/IconCustom.vue";
import {mapGetters} from "vuex";

import UPLOAD_MEDIA from "@/graphql/mutations/UploadMedia.gql";

export default {
  name: "UploadImages",
  components: {
    IconCustom,
  },
  props: {
    images: {
      type: Array,
      default() {
        return []
      },
    },
    defaultImageId: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      loading: false,
      form: {
        default_image_id: null,
        images: []
      }
    }
  },
  computed: {
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
  },
  watch: {
    images: {
      handler: function (newVal) {
        this.form.images = newVal;
      },
      deep: true
    },
    defaultImageId: {
      handler: function (newVal) {
        this.form.default_image_id = newVal;
      },
    },
  },
  mounted() {
    if(this.images && this.images.length > 0) this.form.images = this.images;
    if(this.defaultImageId) this.form.default_image_id = this.defaultImageId;
  },
  methods: {
    removeObjectWithUuid(arr, id) {
      const objWithIdIndex = arr.findIndex((obj) => obj.uuid === id);

      if (objWithIdIndex > -1) {
        arr.splice(objWithIdIndex, 1);
      }

      return arr;
    },
    async uploadImage(file) {
      return await this.$apollo.mutate({
        mutation: UPLOAD_MEDIA,
        variables: {
          whitelabel_uuid: this.getWhiteLabel.uuid,
          collection: 'images',
          file,
        }
      });
    },
    async setImage(e) {
      try {
        this.loading = true;
        const {data} = await this.uploadImage(e.target.files[0])
        if (data && data.uploadMedia) {
          if (!this.form.images.length) {
            this.setDefaultImage(data.uploadMedia.id)
          }
          this.form.images.push(data.uploadMedia)
        }
      } catch (e) {
        // console.error(e);
      }
      this.loading = false;
    },
    async removeImage(uuid, isDefault) {
      this.form.images = this.removeObjectWithUuid(this.form.images, uuid);
      if (isDefault && this.form.images.length) {
        this.form.default_image_id = this.form.images[0].id;
      }
    },
    setDefaultImage(id) {
      this.form.default_image_id = id;
    },

    save() {
      this.$emit('saveImages', this.form);
    },
  },
}
</script>
<style lang="scss" scoped>
.image-preview {
  .image-wrapper {
    border: 1px solid #d2d2d2;
    border-radius: 8px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    position: relative;
    background: rgba(0, 0, 0, 0.03);
    max-height: 150px;

    &.default {
      border: 1px solid #0039ec;
    }

    .blur-box {
      background: rgba(0, 0, 0, 0.5);
      width: 40px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
    }

    .delete-action {
      cursor: pointer;
      position: absolute;
      bottom: 10px;
      right: 10px;

    }

    .hint-wrapper {
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
}

.load-image-wrapper {
  border: 1px solid #d2d2d2;
  border-radius: 8px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  min-height: 132px;
  max-height: 150px;

  .image {
    margin: 0 auto;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;

    i {
      margin: 5px 0 0;
      font-size: 26px;
    }

    p {
      margin: 7px 0 0 !important;

      &:first-of-type {
        font-weight: 700;
      }

      line-height: 0.85rem;
    }

    small {
      font-size: 11px;
    }

    &.no-border {
      border: 0 !important;
    }
  }
}
</style>
